function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#167EE6"
    },
    d: "M256,512c-0.913,0-1.837-0.076-2.75-0.228C129.087,491.076,38.957,384.684,38.957,258.805V83.478 c0-9.217,7.479-16.696,16.696-16.696c78.946,0,133.49-25.577,191.087-63.978c5.609-3.739,12.914-3.739,18.522,0 c57.608,38.401,112.14,63.978,191.086,63.978c9.217,0,16.696,7.479,16.696,16.696v175.327c0,125.881-90.131,232.272-214.293,252.967 C257.837,511.924,256.913,512,256,512z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2860CC"
    },
    d: "M258.75,511.772c124.162-20.696,214.293-127.087,214.293-252.967V83.478 c0-9.217-7.479-16.696-16.696-16.696c-78.946,0-133.478-25.577-191.087-63.978C262.457,0.935,259.228,0,256,0v512 C256.913,512,257.837,511.924,258.75,511.772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2860CC"
    },
    d: "M256,400.696c-82.858,0-150.261-67.403-150.261-150.261S173.142,100.174,256,100.174 s150.261,67.403,150.261,150.261S338.858,400.696,256,400.696z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D43B3"
    },
    d: "M406.261,250.435c0-82.858-67.403-150.261-150.261-150.261v300.522 C338.858,400.696,406.261,333.293,406.261,250.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6F3FF"
    },
    d: "M292.638,293.879c14.911-11.177,24.579-28.987,24.579-49.01c0-33.75-27.468-61.217-61.217-61.217 s-61.217,27.468-61.217,61.217c0,20.023,9.668,37.832,24.579,49.01c-30.989,7.74-58.946,25.301-80.053,51.12 c27.57,33.959,69.643,55.697,116.691,55.697s89.121-21.738,116.691-55.697C351.584,319.18,323.627,301.619,292.638,293.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFDBE6"
    },
    d: "M292.638,293.879c14.911-11.177,24.579-28.987,24.579-49.01c0-33.75-27.468-61.217-61.217-61.217 c0,41.249,0,171.619,0,217.043c47.048,0,89.121-21.738,116.691-55.697C351.584,319.18,323.627,301.619,292.638,293.879z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSvgrepoCom);
export default __webpack_public_path__ + "static/media/account-svgrepo-com.75c45bac34f694ebe1a4ed77bb571ef3.svg";
export { ForwardRef as ReactComponent };